module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cb666b99d3528f91b52f985dfb102afa.svg";